export function renderQuantity(container, tabBtnClass = '.js-files-tab-link') {
    let quantityInfo = $(container).find('.js-support-count'),
        slug = $(container).attr('data-container'),
        btn = $(`${tabBtnClass}[data-slug=${slug}]`),
        btnWrapper = $('.js-flies-nav'),
        btnCount = btn.find('.js-files-number');

    if (quantityInfo.length > 0) {
        let count = quantityInfo.text();
        if (btnCount.length > 0) {
            btnCount.html(`&nbsp;(${count})`).addClass('visible');
            btnWrapper.addClass('result');
        }
    } else {
        if (btnCount.length > 0) {
            btnCount.html('').removeClass('visible');
            btnWrapper.removeClass('result');
        }
    }
}

export function fileAjax(data, tab, cb) {
    const btn = $('.js-submit-btn')
    btn.addClass('loading')
    $.ajax({
        type: 'POST',
        url: ajax_url[0],
        dataType: "html",
        data: data,
        success: function (response) {
            tab.html(response);
            setTimeout(() => {
                cb();
                btn.removeClass('loading')
            }, 100)

        },
        error: function (error) {
            console.log('error', error);
        }
    });
}

export function initSearch(cb, form = '.js-file-form', tabBtnClass = '.js-files-tab-link', tabClass = '.js-tab', parentClass = '.files') {

    if ($(parentClass).length > 0) {
        $(form).on('submit', (ev) => {
            ev.preventDefault();
            let parent = $(ev.currentTarget).parents(parentClass),
                tabBtn = $(parent).find(tabBtnClass);

            let query = $(ev.currentTarget).find('input[type=search]').val();

            $(tabBtn).each((i, btn) => {
                let slug = $(btn).attr('data-slug'),
                    data = {
                        action: 'file_search',
                        slug: slug,
                        query: query
                    };

                $(btn).removeClass('active');

                let container = $(`${tabClass}[data-container=${slug}]`);

                fileAjax(data, container, function () {
                    // renderQuantity(container);
                    if(cb) {
                        cb();
                    }
                })

            })
        });
    }
}

export function resetSearch (form = '.js-file-form', tabBtnClass = '.js-files-tab-link') {
    $(form).find('input[type=search]').val('');
    $('.js-flies-nav').removeClass('result');

    $(tabBtnClass).each((i, btn)=> {
        let btnCount = $(btn).find('.js-files-number');

        btnCount.html('').removeClass('visible');
    })

}

